import Edit16 from '@carbon/icons-react/es/edit/16';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { FormInstanceApi } from 'api/form';
import { Menu } from 'components/atoms/dropdown/menu';
import { MoreActionsDropdown } from 'components/atoms/more-actions';
import { toastService } from 'components/molecules/toast';
import { PermissionRuleName } from 'constant';
import { updateTaskSagaAction } from 'data/tasks/actions';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslate } from 'hooks/use-translation';
import {
  getQueryAllAnswersByFormInstanceKey,
  getQueryAllAnswersByFormTemplateKey,
} from 'queries/form-instance';
import { logger } from 'services';
import { getFormResponsetaskDrawerurl } from 'utils/urls';

export const MoreOptionsRenderer = (params: ICellRendererParams) => {
  const {
    data = {},
    node: { group = false },
  } = params;
  const { taskId, projectId, answerId, formInstanceId, formTemplateId } = data;
  const translate = useTranslate();
  const history = useHistory();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const handleEdit = () => {
    if (taskId && projectId && answerId) {
      return history.push(
        getFormResponsetaskDrawerurl(projectId, taskId, answerId),
      );
    }

    return logger.error('Form responses incomplete data', {
      error: new Error(
        getFormResponsetaskDrawerurl(projectId, taskId, answerId),
      ),
    });
  };

  const onQuestionDeleteOk = async () => {
    await FormInstanceApi.deleteFormAnswer(answerId)
      .then(async () => {
        toastService({
          title: translate('success'),
          message: translate('forms.response.delete_answer_success_message'),
        }).success();
        if (formTemplateId) {
          await queryClient.invalidateQueries(
            getQueryAllAnswersByFormTemplateKey(formTemplateId),
          );
        }
        if (formInstanceId) {
          await queryClient.invalidateQueries(
            getQueryAllAnswersByFormInstanceKey(formInstanceId),
          );
        }
        dispatch(
          updateTaskSagaAction({
            projectId,
            taskId,
            data: {},
          }),
        );
      })
      .catch(() => {
        toastService({
          title: translate('forms.response.delete_answer_error_message'),
          message: '',
        }).error();
      });
  };
  const deleteAnswerConfirmation = useDeleteConfirmModal({
    title: translate('forms.response.delete_answer_title'),
    content: translate('forms.response.delete_answer_message'),
    onOk: async () => {
      await onQuestionDeleteOk();
    },
  });

  if (group) {
    return null;
  }

  return (
    <MoreActionsDropdown
      className="fr-more-actions"
      placement="bottomLeft"
      menu={
        <Menu>
          <Menu.Header>
            <FormattedMessage id="more_actions" />
          </Menu.Header>
          <Menu.ItemEdit
            ruleName={PermissionRuleName.FormResponseEditAction}
            key="edit"
            icon={<Edit16 />}
            onClick={handleEdit}
          >
            <FormattedMessage id="projects.form_responses.edit" />
          </Menu.ItemEdit>
          <Menu.ItemDelete
            ruleName={PermissionRuleName.FormResponseDeleteAction}
            key="delete"
            onClick={deleteAnswerConfirmation}
          >
            <FormattedMessage id="projects.form_responses.delete" />
          </Menu.ItemDelete>
        </Menu>
      }
    />
  );
};
